import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
export const defaultPasswordApiErrorDisplayText = {
    passwordContainsEmailErrorMessage: 'Password cannot contain your email address.',
    passwordMaximumLengthExceededErrorMessage: 'Password exceeds the value for maximum password length allowed.',
    passwordMinimumLengthNotMetErrorMessage: "Password doesn't meet the minimum length required.",
    passwordMinimumNumericCharactersNotMetErrorMessage: "Password doesn't meet the requirements for minimum number of numeric characters.",
    passwordMinimumNonNumericCharacterNotMetErrorMessage: "Password doesn't meet the requirements for minimum number of non-numeric characters.",
    passwordMinimumDistinctCharactersNotMetErrorMessage: "Password doesn't meet the requirements for minimum number of distinct characters.",
    passwordContainsUsernameErrorMessage: 'Password cannot contain your username.',
    passwordContainsGivenOrSurnameErrorMessage: 'Password cannot contain your given name or surname.',
    passwordKnownCompromisedErrorMessage: 'The password you entered is a known compromised password.',
    passwordContainsDisallowedWordsErrorMessage: 'Password contains words which are not allowed.'
};
export const passwordApiErrorDisplayTextValidatorSchema = {
    passwordContainsEmailErrorMessage: nonEmptyStringValidator,
    passwordMaximumLengthExceededErrorMessage: nonEmptyStringValidator,
    passwordMinimumLengthNotMetErrorMessage: nonEmptyStringValidator,
    passwordMinimumNumericCharactersNotMetErrorMessage: nonEmptyStringValidator,
    passwordMinimumNonNumericCharacterNotMetErrorMessage: nonEmptyStringValidator,
    passwordMinimumDistinctCharactersNotMetErrorMessage: nonEmptyStringValidator,
    passwordContainsUsernameErrorMessage: nonEmptyStringValidator,
    passwordContainsGivenOrSurnameErrorMessage: nonEmptyStringValidator,
    passwordKnownCompromisedErrorMessage: nonEmptyStringValidator,
    passwordContainsDisallowedWordsErrorMessage: nonEmptyStringValidator
};
